import React from 'react';
import tw from 'tailwind-styled-components';

import ButtonBase, { ButtonBaseProps } from './ButtonBase';

export const PrimaryButton: React.FC<ButtonBaseProps> = (props) => <StyledButton {...props} />;
export default PrimaryButton;

const StyledButton = tw(ButtonBase)``;
